import { Link } from "react-router-dom";
import { quickCategories } from "@/mocks/categories";
import { movies } from "@/mocks/movies";
import type { Movie } from "@/mocks/movies";

interface CategorySidebarProps {
  activeGenre: string;
}

export default function CategorySidebar({ activeGenre }: CategorySidebarProps) {
  const topRated = [...movies].sort((a, b) => b.score - a.score).slice(0, 5) as Movie[];

  return (
    <aside className="space-y-6">
      <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
        <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
          <i className="ri-apps-2-line text-lg text-primary-600" aria-hidden="true"></i>
          分类导航
        </h3>
        <div className="mt-4 grid grid-cols-2 gap-2">
          {quickCategories.map((item) => {
            const active = activeGenre === item.name;
            return (
              <Link
                key={item.name}
                to={`/category?genre=${encodeURIComponent(item.name)}`}
                className={`flex items-center gap-2 rounded-md px-3 py-2.5 font-label text-sm transition-colors cursor-pointer ${
                  active
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
                {item.name}片
              </Link>
            );
          })}
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
        <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
          <i className="ri-fire-line text-lg text-accent-500" aria-hidden="true"></i>
          高分推荐
        </h3>
        <ul className="mt-4 space-y-3">
          {topRated.map((movie, index) => (
            <li key={movie.id}>
              <Link to={`/detail/${movie.id}`} className="flex items-center gap-3 group cursor-pointer">
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-label text-xs ${
                    index < 3 ? "bg-accent-500 text-primary-950" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {index + 1}
                </span>
                <div className="h-12 w-9 shrink-0 overflow-hidden rounded bg-background-200">
                  <img
                    src={movie.poster}
                    alt={`${movie.title}海报`}
                    title={`${movie.title}海报`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="truncate font-label text-sm text-foreground-900 transition-colors group-hover:text-primary-600">
                    {movie.title}
                  </p>
                  <p className="mt-0.5 flex items-center gap-1 font-label text-xs text-foreground-500">
                    <i className="ri-star-fill text-accent-500" aria-hidden="true"></i>
                    {movie.score.toFixed(1)}
                    <span>·</span>
                    {movie.year}
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}